// !IMPORTANT: keys must be unique
export var formatters = [{
  key: "none",
  text: "None",
  formatter: null
}, {
  key: "integer",
  text: "Integer (1,000)",
  formatter: "0,0"
}, {
  key: "decimal",
  text: "Decimal (1,000.00)",
  formatter: "0,0.00"
}, {
  key: "percentage",
  text: "Percent (%)",
  formatter: "0%" // ToDo: handle them (?)

  /*
  {
    key: "accounting",
    text: "($) accounting",
    formatter: "$ #,##0.00"
  },
  {
    key: "date",
    text: "(MM/DD/YYYY) date",
    formatter: "MM/DD/YYYY"
  },
  {
    key: "time",
    text: "(HH:mm:ss) time",
    formatter: "HH:mm:ss"
  }
  */

}];
export var errors = {
  name_invalid: "name_invalid",
  name_exists: "name_exists",
  empty_value: "empty_value",
  circular_dependency: "circular_dependency",
  column_empty_name: "column_empty_name",
  column_name_exists: "column_name_exists",
  column_name_not_allowed: "column_name_not_allowed",
  column_name_too_long: "column_name_too_long",
  column_formula_circular_dependency: "column_formula_circular_dependency"
};